export default {
    submitSuccess:'提交成功',
    nameEmpty:'请填写您的姓名',
    emailEmpty:'请填写您的邮箱',
    emailError:'您填写的邮箱格式不正确',
    msgEmpty:'请填写留言',
}